module.exports = __webpack_public_path__ + "media/images/countryrect/esperanto-2a89ec375985eb0b8533c005eae0e5f9.svg";